import 'shows/truncateToHeight';
import 'vendor/jquery.isOnScreen';
import { Swiper, Autoplay, EffectFade, Lazy, Pagination } from 'vendor/swiper.esm';
Swiper.use([Autoplay, EffectFade, Pagination]);
import { trackAction } from 'helpers/trackingOM';

(function () {
    window.Homepage = {};
    window.Homepage.tracking = {};
})();

import VideoHeroController from './VideoHeroController';

(function () {
    let heroSelector = '#hero-slider';
    let heroPlus = heroSelector + ',#programming-alerts';
    let hero = $(heroSelector).not('.hero-placeholder');
    let heroContent = $('#hero-content-slider');
    let heroSpacer = $('#hero-content');
    let swiperEnabled = false;
    let heroContentSwiper;
    let heroDoc = document.querySelector(heroSelector);

    let startIndex = 0;
    let previousIndex = 0;
    let slideCount = 0;
    let scrolledOffHero = false;
    let scrolledBackOn = false;
    let numSlides = $('li.hero__slide').length - 1;
    let firstFlag = true;
    let cycleCount = 0;

    let is_paused = false;
    let _visibleHero = true;
    let userProfilesActive = false;
    let resizing = false;

    let videoHeroController;

    let bundleStatus = CBS.Registry.user.bundleStatus ? CBS.Registry.user.bundleStatus : '';

    // check if we are on a hub page (for marquee action str)
    let isHub =
        document.location.href.indexOf('/brands/') > 1 ||
        document.location.href.indexOf('/collections/') > 1;

    if (hero.find('.slide-js').length === 1) {
        let heroVolume = $('.hero-volume');

        videoHeroController = new VideoHeroController(heroVolume, null);
        videoHeroController.trackingEndedCallback = () => {
            trackAction('trackSpliceComplete', {
                pageType: 'show',
                showSectionTitle: 'home',
                showSeriesId: utag_data.showSeriesId,
                showSeriesTitle: utag_data.showSeriesTitle,
                contentBrand: utag_data.contentBrand,
                spliceEnabled: '1',
            });
        };

        videoHeroController.trackingPlayingCallback = () => {
            trackAction('trackSpliceView', {
                pageType: 'show',
                showSectionTitle: 'home',
                showSeriesId: utag_data.showSeriesId,
                showSeriesTitle: utag_data.showSeriesTitle,
                contentBrand: utag_data.contentBrand,
                spliceEnabled: '1',
            });
        };

        let $video = $('.marqueeVideoContainer video');
        if ($video.length > 0) {
            videoHeroController.playSplice($video);
        } else {
            // Hide volume button if there is no splice video.
            heroVolume.hide();
        }
    } else {
        let heroSwiper = new Swiper(hero, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: false,
            navigation: false,
            speed: 500,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            on: {
                init: function () {
                    if (typeof this.slides[0] !== 'undefined') {
                        let trackingData =
                            this.slides[0].attributes['data-tracking'].value.split('|');
                        let initTrackingTimeout = setTimeout(function () {
                            setTrackingCallbacks(videoHeroController, trackingData);
                        }, 500);

                        return;
                    }
                },
            },
        })
            .on('transitionStart', () => {
                // Using transitionStart and transitionEnd to fix aria accessibility notifications duplicated.
                const items = heroDoc.querySelectorAll('.swiper-slide');
                for (const item of items) {
                    item.setAttribute('aria-hidden', 'true');
                }
            })
            .on('transitionEnd', function () {
                if (!resizing) {
                    if (firstFlag) {
                        trackSlide(true);
                    }
                    trackSlide(false);
                }
            })
            .on('slideChange', () => {
                return;
            });

        let heroVolume = $('.hero-volume');

        heroContentSwiper = new Swiper(heroContent, {
            loop: false,
            navigation: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
                renderBullet: function () {
                    return '<span class="swiper-pagination-bullet"><i></i><b></b></span>';
                },
            },
            speed: 500,
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            },
            slidesPerView: 1,
            slidesPerGroup: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            on: {
                init: function () {
                    setTimeout(() => {
                        let $video = $('#marqueeVideo0');
                        if ($video.length > 0) {
                            videoHeroController.playSplice($video);
                        }
                    }, 3);
                },
            },
        })
            .on('transitionStart', function () {
                //heroSwiper.slideTo(this.activeIndex);
            })
            .on('slideChange', function () {
                heroSwiper.slideTo(this.activeIndex);
                videoHeroController.reset();
                let $video = $('#marqueeVideo' + this.realIndex);
                if ($video.length > 0) {
                    videoHeroController.playSplice($video);
                }

                const activeIndex = heroSwiper.realIndex;
                const currentSlide = heroSwiper.slides[activeIndex];
                let trackingData = currentSlide.attributes['data-tracking'].value.split('|');
                setTrackingCallbacks(videoHeroController, trackingData);
            })
            .on('reachBeginning', function () {
                cycleCount++;
            });

        videoHeroController = new VideoHeroController(heroVolume, heroContentSwiper);
        is_paused = false;
        let complementaryLandmark = $('<aside aria-label="Carousel Pause/Play Button"></aside>');
        let pauseCarousel = $('<button >Pause Carousel</button>');
        pauseCarousel.attr({
            id: 'carousel-pause-button',
        });

        complementaryLandmark.append(pauseCarousel);
        $('body').prepend(complementaryLandmark);

        $('#carousel-pause-button').on('click', function (e) {
            if (is_paused) {
                videoHeroController.stopHero(true, true);
                $(this).text('Pause Carousel');
            } else {
                videoHeroController.stopHero(false);
                $(this).text('Play Carousel');
            }
            is_paused = !is_paused;
        });

        if (!CBS.Registry.platform.isMobile) {
            // heroSpacer
            //  .mouseenter(function () {
            //     videoHeroController.stopHero(true, true)
            // })
            //  .mouseleave(function () {
            //     videoHeroController.stopHero(false)
            // });
        }

        $(window).scroll(debounce(() => handleScroll()));

        $(document).ready(function () {
            //to handle when Who's Watching SPECIFICALLY automatically loads at the beginning
            let userProfileFlag = $('#who-s-watching');
            if (userProfileFlag.length > 0) {
                setTimeout(() => {
                    //give content time to start, otherwise it will start after you tell it to stop...
                    videoHeroController.stopHero(true, true);
                    heroContentSwiper.autoplay.stop();
                    is_paused = true;
                    userProfilesActive = true;
                }, 3000);
            }
        });

        window.addEventListener(
            //to handle when user manually turns User Profiles on
            'userProfilesOn',
            function (evt) {
                //when User Profiles are engaged stop the carousel from sliding slides
                videoHeroController.stopHero(true, true);
                heroContentSwiper.autoplay.stop();
                is_paused = true;
                userProfilesActive = true;
            },
            false,
        );

        window.addEventListener(
            //handles when User Profiles turn off, should the page not reload for any reason.
            'userProfilesOff',
            function (evt) {
                //when User Profiles are not engaged let the marquee know
                userProfilesActive = false;
            },
            false,
        );

        swiperEnabled = true;
    }

    //suppress over-reporting tracking impressions on window.resize
    let timeout = false;
    function resizeDebounced() {
        resizing = false;
    }
    window.addEventListener('resize', function () {
        resizing = true;
        clearTimeout(timeout);
        timeout = setTimeout(resizeDebounced, 4000);
    });

    function handleScroll() {
        _visibleHero = $('#hero-content').isOnScreen();
        if (!_visibleHero) {
            if (swiperEnabled) {
                videoHeroController.stopHero(true, true);
                if (!$('.hero-volume').hasClass('muted')) {
                    videoHeroController.setMute(true);
                }
                scrolledOffHero = true;
                is_paused = true;
                cycleCount = 0;
            }
        } else {
            if (swiperEnabled) {
                videoHeroController.stopHero(false);
                scrolledOffHero = false;
                is_paused = false;
            }
        }
    }

    function setTrackingCallbacks(videoHeroController, trackingData) {
        videoHeroController.trackingEndedCallback = () => {
            if (!userProfilesActive) {
                let action = isHub ? 'trackHubMarqueeSpliceComplete' : 'trackMarqueeSpliceComplete';
                trackAction(action, {
                    pageType: trackingData[5],
                    screenName: '/',
                    slideId: trackingData[12],
                    slideTitle: trackingData[13],
                    slideTarget: trackingData[14],
                    slideCTA: trackingData[3],
                    slideType: trackingData[15],
                    showSectionTitle: 'home',
                    showSeriesId: trackingData[6],
                    showSeriesTitle: trackingData[7],
                    contentBrand: trackingData[8],
                    movieId: trackingData[9],
                    movieTitle: trackingData[10],
                    movieGenre: trackingData[11],
                    movieSectionTitle: 'home',
                    spliceEnabled: '1',
                    contentLocked: trackingData[17],
                    bundleStatus: bundleStatus,
                });
            }
        };

        videoHeroController.trackingPlayingCallback = () => {
            if (!userProfilesActive) {
                let action = isHub ? 'trackHubMarqueeSpliceView' : 'trackMarqueeSpliceView';
                trackAction(action, {
                    pageType: trackingData[5],
                    screenName: '/',
                    slideId: trackingData[12],
                    slideTitle: trackingData[13],
                    slideTarget: trackingData[14],
                    slideCTA: trackingData[3],
                    slideType: trackingData[15],
                    slideCycle: cycleCount.toString(),
                    showSectionTitle: 'home',
                    showSeriesId: trackingData[6],
                    showSeriesTitle: trackingData[7],
                    contentBrand: trackingData[8],
                    movieId: trackingData[9],
                    movieTitle: trackingData[10],
                    movieGenre: trackingData[11],
                    movieSectionTitle: 'home',
                    spliceEnabled: '1',
                    contentLocked: trackingData[17],
                    bundleStatus: bundleStatus,
                });
            }
        };

        videoHeroController.trackingVolumeCallback = (actionType) => {
            let _posColNum = trackingData[4] - 1;
            trackAction(actionType, {
                slideId: trackingData[12],
                slideTitle: trackingData[13],
                slideTarget: trackingData[14],
                slideCTA: trackingData[3],
                slideType: trackingData[15],
                rowHeaderTitle: 'Home Marquee',
                posRowNum: '0',
                posColNum: _posColNum.toString(),
                slideCycle: cycleCount.toString(),
                showSectionTitle: 'home',
                showSeriesId: trackingData[6],
                showSeriesTitle: trackingData[7],
                showEpisodeId: '',
                showEpisodeTitle: '',
                movieId: trackingData[9],
                movieTitle: trackingData[10],
                movieSectionTitle: 'home',
                contentLocked: trackingData[17],
                bundleStatus: bundleStatus,
            });
        };
    }

    function debounce(func, timeout = 250) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    function trackSlide(_initialSlide) {
        let item =
            firstFlag && typeof $('li.swiper-slide-active')[0] !== 'undefined'
                ? $('li.swiper-slide-prev')[0]
                : $('li.swiper-slide-active')[0];
        let itemCTA = $('li.swiper-slide-active .cta-box > a')[0];
        if (_initialSlide) {
            firstFlag = false;
        }

        if (item) {
            let dd = item.getAttribute('data-tracking').split('|');
            let _screenName = $('#global-header-container .user-profile-name').text() ?? '';
            let spliceEnabled = $('.hero__wrapper .swiper-slide-active .marqueeVideo').length
                ? '1'
                : '0';

            item.setAttribute('aria-hidden', 'false');

            if (dd !== undefined) {
                let isMovie = dd[5] === 'movie';
                let posColNum = dd[4] - 1;

                let action = 'trackMarqueeView';
                let obj = {
                    liveTvChannel: 'undefined',
                    slideId: dd[12],
                    slideTitle: dd[13],
                    slideTarget: dd[14],
                    slideCTA: dd[3],
                    slideType: dd[15] ?? '',
                    rowHeaderTitle: 'Home Marquee',
                    posRowNum: '0',
                    posColNum: posColNum.toString(),
                    slideCycle: cycleCount.toString(),
                    showSectionTitle: !isMovie ? 'home' : '',
                    showSeriesId: !isMovie ? dd[6] : '',
                    showSeriesTitle: !isMovie ? dd[13] : '',
                    screenName: _screenName,
                    contentBrand: dd[8] ?? '',
                    movieSectionTitle: isMovie ? 'home' : '',
                    movieId: isMovie || dd[6] == '61457287' ? dd[9] : '',
                    movieTitle: isMovie ? dd[10] : '',
                    movieGenre: isMovie ? dd[11] : '',
                    spliceEnabled: spliceEnabled,
                    contentLocked: dd[17],
                    bundleStatus: bundleStatus,
                };

                if (isHub) {
                    action = 'trackHubMarqueeView';
                    obj.rowHeaderTitle = 'Hub Marquee';
                    obj.hubId = CBS.Tracking.utag_data.hubId ? CBS.Tracking.utag_data.hubId : '';
                    obj.hubSlug = CBS.Tracking.utag_data.hubSlug
                        ? CBS.Tracking.utag_data.hubSlug
                        : '';
                    obj.hubPageType = CBS.Tracking.utag_data.hubPageType
                        ? CBS.Tracking.utag_data.hubPageType
                        : '';

                    if (itemCTA.href.indexOf('live-tv') > -1) {
                        let liveTvChannel = dd[13];
                        if (itemCTA.href.indexOf('stream/cbsn') > 1) {
                            liveTvChannel = 'CBSN Live Stream';
                        } else if (itemCTA.href.indexOf('stream') > 1) {
                            liveTvChannel = 'Live Local TV';
                        }
                        obj.liveTvChannel = liveTvChannel;
                    }
                }

                try {
                    if (om && _visibleHero && slideCount < 50) {
                        trackAction(action, obj);
                        slideCount++;
                    }
                } catch (e) {
                    console.error(action + ' failed to load');
                }
            }
        }
    }

    //setupParallax(); disabling too choppy will revisit

    runTruncateDescription();

    function setupParallax() {
        $(window).scroll(function () {
            let scrollPos = $(window).scrollTop();

            if (scrollPos > 0) {
                if (swiperEnabled) {
                    heroContentSwiper.autoplay.stop();
                }

                if (scrollPos > 200) {
                    // pausing vilynx
                    pauseVilynx(hero.find('.vilynx_enabled'));
                } else {
                    //  resuming vilynx
                    resumeVilynx(hero.find('.vilynx_enabled'));
                }
            } else {
                if (swiperEnabled) {
                    heroContentSwiper.autoplay.start();
                }
            }

            hero.css('transform', 'translateY(' + -scrollPos / 6.5 + 'px)');
        });
    }

    function pauseVilynx(target) {
        if (!target.hasClass('vilynx_stop')) {
            target.addClass('vilynx_stop');
        }
    }

    function resumeVilynx(target) {
        if (target.hasClass('vilynx_stop')) {
            target.removeClass('vilynx_stop');
        }
    }

    function runTruncateDescription() {
        let el = document.getElementById('hero-description');

        if (el && typeof el.style.webkitLineClamp === 'undefined') {
            TruncateToHeight.truncate({
                heightElementId: 'hero-description-box',
                contentElementId: 'hero-description',
            });
        }
    }

    $('.swiper-wrapper .swiper-slide .hero__content-slide-wrapper .button').on(
        'click',
        function (event) {
            let $item = $(this);
            let item = $item[0];
            let data = $item.attr('aa-link'); //original click link
            let aaLink = data.split('|');
            let $activeSlide = $('.hero__wrapper .swiper-slide-active');
            let spliceEnabled = $activeSlide.find('.marqueeVideo').length ? '1' : '0';
            localStorage.setItem('spliceEnabled', spliceEnabled);
            let preRowHeaderTitle;
            let rowHeaderT;

            if (CBS.Registry.homepage) {
                try {
                    let item = $('li.swiper-slide-active')[0];
                    let dd = $activeSlide[0].getAttribute('data-tracking').split('|');
                    let _screenName = $('#global-header-container .user-profile-name').text() ?? '';
                    let posColNum = dd[4] - 1;
                    let isMovie = dd[5] === 'movie';

                    preRowHeaderTitle = isMovie ? 'movie hero' : 'show hero';
                    if (aaLink[0] == 'marquee') {
                        preRowHeaderTitle = 'marquee';
                    }

                    rowHeaderT = CBS.Registry.homepage ? 'Home Marquee' : preRowHeaderTitle;

                    let action = 'trackMarqueeSelect';

                    let obj = {
                        liveTvChannel: 'undefined',
                        slideId: dd[12],
                        slideTitle: dd[13],
                        slideTarget: dd[14],
                        ctaText: aaLink[2],
                        slideCTA: dd[3],
                        slideType: dd[15] ?? '',
                        rowHeaderTitle: rowHeaderT,
                        posRowNum: '0',
                        posColNum: posColNum.toString(),
                        slideCycle: cycleCount.toString(),
                        showSectionTitle: !isMovie ? 'home' : '',
                        showSeriesId: !isMovie ? dd[6] : '',
                        showSeriesTitle: !isMovie ? aaLink[4] : '',
                        showGenre: dd[11] ?? 'undefined',
                        showDayPart: 'undefined',
                        showEpisodeId:
                            typeof aaLink[16] === 'undefined' && !isMovie
                                ? 'undefined'
                                : aaLink[16],
                        showEpisodeTitle: aaLink[4] && !isMovie ? aaLink[4] : '',
                        showEpisodeLabel: aaLink[4] && !isMovie ? aaLink[4] : '',
                        showSeasonNumber: aaLink[6] && !isMovie ? aaLink[6] : '',
                        showEpisodeNumber: aaLink[7] && !isMovie ? aaLink[7] : '',
                        showAirDate: aaLink[8],
                        screenName: _screenName.toString(),
                        contentBrand: dd[8] ?? '',
                        movieSectionTitle: isMovie ? 'home' : '',
                        movieId: isMovie ? dd[9] : '',
                        movieTitle: isMovie ? dd[10] : '',
                        movieGenre: isMovie ? dd[11] : '',
                        spliceEnabled: spliceEnabled,
                        contentLocked: dd[17],
                        bundleStatus: bundleStatus,
                    };

                    trackAction(action, obj);
                } catch (e) {
                    console.log('error - ' + event);
                }
            } else {
                let data = $item.attr('aa-link');
                //var d = data.split('|');
                let bUrl = $item.attr('href');
                try {
                    let aaLink = data.split('|');
                    let posColNum = aaLink[3] - 1;
                    posColNum = posColNum < 0 ? 0 : posColNum;

                    let __contentBrand = aaLink[10];
                    __contentBrand = __contentBrand !== '' ? __contentBrand : 'na';

                    preRowHeaderTitle = isMovie ? 'movie hero' : 'show hero';
                    rowHeaderT = CBS.Registry.homepage ? 'Home Marquee' : preRowHeaderTitle;

                    let showSeriesTitle = aaLink[4];
                    if (aaLink[22] != '') {
                        showSeriesTitle = aaLink[4] + ' ' + aaLink[22];
                    }
                    let isMovie =
                        typeof CBS.Registry.MovieTitle !== 'undefined' || aaLink[20] === 'movie';

                    let preRowHeaderTitle = isMovie ? 'movie hero' : 'show hero';
                    if (aaLink[0] == 'marquee') {
                        preRowHeaderTitle = 'marquee';
                    }

                    let rowHeaderT = CBS.Registry.homepage ? 'Home Marquee' : preRowHeaderTitle;
                    var mobj = {
                        posRowNum: '0',
                        posColNum: posColNum.toString(),
                        contentLocked: aaLink[23],
                        liveTvChannel: 'undefined',
                        showSectionTitle: !isMovie ? 'home' : '',
                        showSeriesId: !isMovie ? aaLink[11] : '',
                        showSeriesTitle: !isMovie ? showSeriesTitle : '',
                        showGenre: !isMovie ? aaLink[15] : '',
                        showDayPart: 'undefined',
                        showEpisodeId:
                            typeof aaLink[16] === 'undefined' && !isMovie
                                ? 'undefined'
                                : aaLink[16],
                        showEpisodeTitle: aaLink[5] && !isMovie ? aaLink[5] : '',
                        showEpisodeLabel: aaLink[5] && !isMovie ? aaLink[5] : '',
                        showSeasonNumber: aaLink[6] && !isMovie ? aaLink[6] : '',
                        showEpisodeNumber: aaLink[7] && !isMovie ? aaLink[7] : '',
                        showAirDate: aaLink[8],
                        slideType: aaLink[17],
                        slideCycle: cycleCount.toString(),
                        slideId: aaLink[19],
                        slideTitle: isMovie ? aaLink[5] : aaLink[4],
                        slideTarget: bUrl,
                        slideCTA: aaLink[2],
                        ctaText: aaLink[2],
                        targetURL: bUrl,
                        targetType: aaLink[2] + '|' + bUrl,
                        assetTitle: isMovie ? aaLink[5] : aaLink[4],
                        rowHeaderTitle: rowHeaderT,
                        contentBrand: __contentBrand,
                        movieId: isMovie ? aaLink[11] : '',
                        movieTitle: isMovie ? aaLink[5] : '',
                        movieGenre: isMovie ? aaLink[15] : '',
                        spliceEnabled: spliceEnabled,
                    };

                    // badge type and lock state (if set) @todo duplicate in JsCarousel.js reuse?
                    mobj[aaLink[13] === 'p' ? 'PPlusSubscriberBadge' : 'TVELockedBadge'] =
                        aaLink[14];

                    let action =
                        CBS.Registry.homepage || CBS.Registry.kidsLanding
                            ? 'trackMarqueeSelect'
                            : 'trackShowHero';

                    if (isHub) {
                        action = 'trackHubMarqueeSelect';
                        mobj.rowHeaderTitle = 'Hub Marquee';
                        mobj.hubId = CBS.Tracking.utag_data.hubId
                            ? CBS.Tracking.utag_data.hubId
                            : '';
                        mobj.hubSlug = CBS.Tracking.utag_data.hubSlug
                            ? CBS.Tracking.utag_data.hubSlug
                            : '';
                        mobj.hubPageType = CBS.Tracking.utag_data.hubPageType
                            ? CBS.Tracking.utag_data.hubPageType
                            : '';

                        if (item.href.indexOf('live-tv') > -1) {
                            let liveTvChannel = aaLink[13];
                            if (item.href.indexOf('stream/cbsn') > 1) {
                                liveTvChannel = 'CBSN Live Stream';
                            } else if (item.href.indexOf('stream') > 1) {
                                liveTvChannel = 'Live Local TV';
                            }
                            mobj.liveTvChannel = liveTvChannel;
                        }
                    }

                    localStorage.setItem(
                        'trackHeroCtaText',
                        JSON.stringify({ ctaText: mobj.ctaText }),
                    );
                    window.localStorage.setItem('metadata-video-tracking', JSON.stringify(mobj));

                    trackAction(action, mobj);
                } catch (e) {
                    console.log(e);
                }
            }
        },
    );

    /* add class to hero bullet if it comes into focus */
    $('.swiper-pagination .swiper-pagination-bullet').focus(function () {
        $(this).addClass('got-focus');
    });

    /* remove class when hero bullet with got-focus class comes into focus  */
    $('body').on(
        'keypress',
        '.swiper-pagination .swiper-pagination-bullet.got-focus',
        function (e) {
            var keycode = e.keyCode ? e.keyCode : e.which;
            if (keycode == '13') {
                $(this).removeClass('got-focus');
            }
        },
    );

    /* making sure keyboard tab only focus on the actual slide and not the duplicates */
    $('.swiper-slide-duplicate a').attr('tabindex', '-1');

    /* track which Hero CTA is in focused and slide to that marquee */
    /* Disabling this for now - causing an issue on mweb
    $('.hero__content-slide-wrapper .cta-box a').focus(function () {
        let i = $(this).parents(':eq(2)').data('swiper-slide-index');
        let mySwiper = document.querySelector('#hero-content-slider').swiper;
        if (mySwiper) mySwiper.slideToLoop(i);
    });
    */
})();
